import React from 'react';
import { useIntl } from 'react-intl-next';
import { Date } from '@atlaskit/date';
import { DateSharedCssClassName } from '@atlaskit/editor-common/styles';
import { setDatePickerAt } from '../pm-plugins/actions';
import { getDateInformation } from './utils';
export function DateNodeView(props) {
  var _props$getPos;
  var timestamp = props.node.attrs.timestamp;
  var intl = useIntl();
  var pos = (_props$getPos = props.getPos) === null || _props$getPos === void 0 ? void 0 : _props$getPos.call(props);
  var _getDateInformation = getDateInformation(timestamp, intl, props.view.state, pos),
    displayString = _getDateInformation.displayString,
    color = _getDateInformation.color;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    React.createElement("span", {
      className: DateSharedCssClassName.DATE_WRAPPER,
      onClick: handleClick
    }, /*#__PURE__*/React.createElement(Date, {
      color: color,
      value: timestamp
    }, displayString))
  );
  function handleClick(event) {
    event.nativeEvent.stopImmediatePropagation();
    var _props$view = props.view,
      state = _props$view.state,
      dispatch = _props$view.dispatch;
    setDatePickerAt(state.selection.from)(state, dispatch);
  }
}